module.exports = __webpack_public_path__ + "img/199.b0a8206c.jpg";